// signaling WS 再接続のバックオフ計算とキャンセル可能な sleep。
// host (extension) / viewer で共有する純粋ロジック。DOM 非依存
// (setTimeout / AbortSignal は browser / Workers / Node すべてで利用可能)。

import {
  SIGNALING_RECONNECT_INITIAL_DELAY_MS,
  SIGNALING_RECONNECT_JITTER_RATIO,
  SIGNALING_RECONNECT_MAX_DELAY_MS,
} from "../constants.js";

// attempt 回目 (1-origin) の待機時間 (ms) を指数バックオフ + jitter で算出。
// 同時刻に大量クライアントが再接続してもサーバ側スパイクを避けるため散らす。
export function computeReconnectBackoff(attempt: number): number {
  const base = Math.min(
    SIGNALING_RECONNECT_INITIAL_DELAY_MS * 2 ** (attempt - 1),
    SIGNALING_RECONNECT_MAX_DELAY_MS,
  );
  const jitter =
    base * SIGNALING_RECONNECT_JITTER_RATIO * (Math.random() * 2 - 1);
  return Math.max(0, base + jitter);
}

// ms 待機する。signal が abort されたら即座に reject("aborted")。
export function abortableSleep(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    const onAbort = (): void => {
      clearTimeout(timer);
      reject(new Error("aborted"));
    };
    signal.addEventListener("abort", onAbort);
  });
}
